<template>
  <div class="mr-3 w-1/2 flex-none lg:w-1/4 xl:w-1/6">
    <a :href="productUrl" class="flex h-full flex-col">
      <div
        class="product photo product-item-photo relative flex items-center bg-white pt-[100%]"
        tabindex="-1"
      >
        <span
          class="align-center absolute left-0 top-0 flex h-full w-full flex-wrap content-center overflow-hidden p-2 hover:shadow-sm"
        >
          <img
            :src="item.image_url"
            :alt="item.name"
            class="h-auto w-full self-center rounded-xl border border-gray-ultralight"
            loading="lazy"
            width="500"
            height="500"
          />
        </span>
      </div>
      <span class="mt-3 truncate text-left text-xl font-bold">{{
        item.name
      }}</span>
      <ProductPrice v-if="item.price" :item="item" class="text-highlight" />
    </a>
  </div>
</template>

<script setup lang="ts">
import { AlgoliaHit } from '@/types/Algolia/AlgoliaHit';
import { computed } from 'vue';
import ProductPrice from '@/components/Algolia/ProductPrice.vue';

export type RelatedEntryProps = {
  item: AlgoliaHit;
};

const props = defineProps<RelatedEntryProps>();

const productUrl = computed(() => window.BASE_URL + props.item.url_key);
</script>
